<template>
<div class="chapter">
<div class="inner_page">
<div id="Dear-Reader.html" xml:lang="en-US">
<div class="story">
<p class="pl-fl-roman"><span class="roman">Dear Reader,</span></p>
<p class="pl-fl-roman"><span class="roman">The idea for this story began with a Regency cartoon showing a frantic Norfolk turkey escaping from its Christmas doom in Leadenhall Market. I wondered what became of it and found the answer when my hero rescued the ungrateful bird from a snowdrift. From there the story just grew, set in a snowy Norfolk landscape not far from where I live.</span></p>
<p class="pl-fl-roman"><span class="roman">We don’t often get heavy snow, let alone a white Christmas, in this part of the world, so the idea of my lovers snowed in together was a Christmas fantasy for me, as well as for them.</span></p>
<p class="pl-fl-roman"><span class="roman">I hope Giles and Julia’s story gives you a warm glow this winter, wherever you are.</span></p>
<p class="pl-fl-roman"><span class="roman">A happy Christmas,</span></p>
<p class="pl-fl-roman"><em class="italic">Louise Allen</em></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dear_Reader.vue?18592924